import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import he from './he.json';

const STORAGE_KEY = 'lang';
const RTL_LANGS = new Set(['he']);

function applyDirection(lng: string) {
  const dir = RTL_LANGS.has(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
}

const savedLng = localStorage.getItem(STORAGE_KEY) || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, he: { translation: he } },
    fallbackLng: 'en',
    lng: savedLng,
    interpolation: { escapeValue: false },
  });

applyDirection(savedLng);

export function setLanguage(lng: 'en' | 'he') {
  // The installed i18next/react-i18next type declarations in this repo are
  // malformed (confirmed separately — tsc throws raw syntax errors inside
  // their own .d.ts files), which drops changeLanguage from i18n's inferred
  // type even though it exists at runtime. Cast around it rather than work
  // around a broken upstream .d.ts.
  (i18n as any).changeLanguage(lng);
  localStorage.setItem(STORAGE_KEY, lng);
  applyDirection(lng);
}

export default i18n;
